let isPenSupported: boolean = false;

export function setTextPenSupported() {
    isPenSupported = true;
}

export function isTextPenSupported(): boolean {
    return isPenSupported;
}
